// Small helpers around the Sanctum token + user object we keep in
// localStorage after login/register (see AuthPage + lib/api.js).

export function getToken() {
  return localStorage.getItem('pixnest_token');
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('pixnest_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSession(user, token) {
  localStorage.setItem('pixnest_token', token);
  localStorage.setItem('pixnest_user', JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem('pixnest_token');
  localStorage.removeItem('pixnest_user');
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export function dashboardPathForRole(role) {
  if (role === 'photographer') return '/photographer/dashboard';
  if (role === 'admin') return '/admin';
  return '/client/dashboard';
}

// Pixnest is India/Kolkata based - all prices are in INR.
export function formatINR(amount) {
  const value = Number(amount) || 0;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(value) {
  if (!value) return '';
  try {
    return new Date(value).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return value;
  }
}
